import { theme, themes } from "#blokkli-build/config";
import { ref, onMounted, onBeforeUnmount } from "#imports";
import { rgbaToString } from "./index.js";
import { DragStyle } from "./DragStyle/index.js";
import onBlokkliEvent from "./composables/onBlokkliEvent.js";
export default function() {
  const originalBrowserThemeColor = ref("");
  const THEME_COLOR = "black";
  const accent = ref(theme.accent);
  const mono = ref(theme.mono);
  const teal = ref(theme.teal);
  const yellow = ref(theme.yellow);
  const red = ref(theme.red);
  const lime = ref(theme.lime);
  const themeMap = {
    accent,
    mono,
    teal,
    yellow,
    red,
    lime
  };
  function getColor(color, key) {
    return themeMap[color].value[key];
  }
  function getColorString(color, key, alpha = 1) {
    const rgb = getColor(color, key);
    return rgbaToString(rgb, alpha);
  }
  const customTheme = ref(theme);
  const setColor = (group, shade, value) => {
    if (group === "accent") {
      accent.value[shade] = value;
    } else if (group === "mono") {
      mono.value[shade] = value;
    } else if (group === "teal") {
      teal.value[shade] = value;
    } else if (group === "red") {
      red.value[shade] = value;
    } else if (group === "yellow") {
      yellow.value[shade] = value;
    } else if (group === "lime") {
      lime.value[shade] = value;
    }
    const root = document.querySelector(":root");
    if (root instanceof HTMLElement) {
      root.style.setProperty(
        `--bk-theme-${group}-${shade}`,
        `${value[0]} ${value[1]} ${value[2]}`
      );
    }
  };
  const setColorsFromTheme = (v) => {
    Object.entries(v).forEach(([group, colors]) => {
      Object.entries(colors).forEach(([shade, value]) => {
        setColor(group, shade, value);
      });
    });
  };
  const applyTheme = (name) => {
    customTheme.value = JSON.parse(
      JSON.stringify({
        accent: accent.value,
        mono: mono.value,
        teal: teal.value,
        yellow: yellow.value,
        red: red.value,
        lime: lime.value
      })
    );
    if (name === "custom") {
      return setColorsFromTheme(customTheme.value);
    }
    const themeToApply = themes[name];
    if (themeToApply) {
      setColorsFromTheme(themeToApply);
    }
  };
  onMounted(() => {
    const el = document.head.querySelectorAll('[name="theme-color"]');
    if (el instanceof HTMLMetaElement) {
      originalBrowserThemeColor.value = el.content;
      el.content = THEME_COLOR;
    } else {
      const meta = document.createElement("meta");
      meta.name = "theme-color";
      meta.content = THEME_COLOR;
      const head = document.getElementsByTagName("head")[0];
      if (head) {
        head.appendChild(meta);
      }
    }
  });
  onBeforeUnmount(() => {
    const el = document.head.querySelectorAll('[name="theme-color"]');
    if (el instanceof HTMLMetaElement) {
      if (originalBrowserThemeColor.value) {
        el.content = originalBrowserThemeColor.value;
      } else {
        el.remove();
      }
    }
  });
  const dragStyle = new DragStyle();
  function invalidateCachedStyle(el) {
    dragStyle.invalidateStyle(el);
  }
  onBlokkliEvent("state:reloaded", function() {
    dragStyle.reset();
  });
  return {
    accent,
    mono,
    teal,
    yellow,
    red,
    lime,
    getDraggableStyle: function(el) {
      return dragStyle.getStyle(el, theme.accent[700]);
    },
    invalidateCachedStyle,
    setColor,
    applyTheme,
    getColor,
    getColorString
  };
}
